import { Text, View } from "@react-pdf/renderer";
import CfmReportStyles from "../../CfmReportStyles";
import { formatCurrency } from "../../Utils/formatCurrency";

const PersonalDetailsSection = ({
  state,
  primaryColor,
  inflation,
  dropRiskData,
  pensions = [],
  investments = [],
  otherIncomeSources = [],
  notes = "",
}) => {
  const person = state || {};
  const styles = CfmReportStyles(primaryColor);

  // console.log("PersonalDetailsSection", {
  //   person,
  //   inflation,
  //   dropRiskData,
  //   pensions,
  //   investments,
  //   otherIncomeSources,
  // });
  return (
    <View style={[styles.section]}>
      <Text style={styles.disclaimerText1}>
        This section outlines your personal and financial information, along
        with any economic assumptions or stress testing.
      </Text>
      {notes && (
        <View style={styles.column}>
          <Text style={styles.subTitle}>Adviser Insights</Text>
          <Text style={styles.text}>{notes}</Text>
        </View>
      )}
      <View style={{ ...styles.row, gap: 30 }}>
        {/* Left Column: Personal Info */}
        <View style={{ flex: 2, ...styles.column }}>
          <Text style={styles.subTitle}>Personal Information</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.textBold1}>Name:</Text>
              <Text style={styles.textBold1}>Date of Birth:</Text>
              <Text style={styles.textBold1}>Salary:</Text>
              <Text style={styles.textBold1}>Expenditure:</Text>
              <Text style={styles.textBold1}>Retirement Age:</Text>
              <Text style={styles.textBold1}>Retirement Expenditure:</Text>
            </View>
            <View
              style={{
                ...styles.column,
                alignItems: "flex-end",
              }}
            >
              <Text style={styles.text}>{person.name || "N/A"}</Text>
              <Text style={styles.text}>{person.dob || "N/A"}</Text>
              <Text style={styles.text}>
                {formatCurrency(person.salary?.value)} (
                {person.salary?.unit === "Annual" ? "per annum" : "per month"})
              </Text>
              <Text style={styles.text}>
                {formatCurrency(person.currentExpenditure?.value)} (
                {person.currentExpenditure?.unit === "Annual"
                  ? "per annum"
                  : "per month"}
                )
              </Text>
              <Text style={styles.text}>{person.retirementAge || "N/A"}</Text>
              <Text style={styles.text}>
                {formatCurrency(person.retirementExpenditure?.value)} (
                {person.retirementExpenditure?.unit === "Annual"
                  ? "per annum"
                  : "per month"}
                )
              </Text>
            </View>
          </View>
        </View>

        {/* Right Column: Inflation & Drop Risk */}
        <View style={{ flex: 3 }}>
          <View style={styles.column}>
            <Text style={styles.subTitle}>Inflation Rate</Text>
            <Text style={styles.text}>
              An inflation rate of {inflation || 0}% per annum has been applied
              to all the figures used in this report, including to the State
              Pension. The only exception only applies to Ad hoc contributions
              or withdrawals, which will be modelled using the exact amounts you
              request.
            </Text>
          </View>
          {dropRiskData?.length > 0 && (
            <View style={styles.column}>
              <Text style={[styles.subTitle, { marginTop: 30 }]}>
                Stress Testing
              </Text>
              <Text style={styles.text}>Potential market drop as % loss:</Text>
              <View style={{ marginTop: 6 }}>
                {dropRiskData.map((item, index) => (
                  <Text key={index} style={styles.text}>
                    • {item.year}: {item.rate}%
                  </Text>
                ))}
              </View>
            </View>
          )}
        </View>
      </View>
    </View>
  );
};

export default PersonalDetailsSection;
